/**
 * Builds the competitionEntries slice from every place an entry can be recorded. Later sources
 * win, so for a competition in more than one the API's answer is the one kept.
 *  - persisted: local storage, which covers unverified giveaways
 *  - competitions: the fetched list, for an API that still flags `userHasAlreadyEntered` on each
 *    competition (the list is now the same for everyone, so a current API does not)
 *  - apiEntries: the signed-in user's own entries, from /user/competition-entries
 * @param {Object} sources
 * @param {{ competitionId: string, entryDate: string }[]} [sources.persisted]
 * @param {Object[]} [sources.competitions]
 * @param {{ competitionId: string, entryDate: string }[]} [sources.apiEntries]
 * @returns {{ competitionId: string, entryDate: string|null }[]}
 */
export default function mergeCompetitionEntries({
  persisted = [], competitions = [], apiEntries = [],
} = {}) {
  const entriesMap = new Map();

  persisted.forEach(({ competitionId, entryDate }) => {
    entriesMap.set(competitionId, { competitionId, entryDate });
  });

  competitions.forEach((c) => {
    if (c.userHasAlreadyEntered) {
      entriesMap.set(c._id, { competitionId: c._id, entryDate: c.entryDate || null });
    }
  });

  apiEntries.forEach(({ competitionId, entryDate }) => {
    entriesMap.set(competitionId, { competitionId, entryDate: entryDate || null });
  });

  return [...entriesMap.values()];
}
